// src/sections/NeigungDerModuleSection.jsx
import React, { useState, useEffect  } from "react";
import axios from "axios";
import { showSuccess, showError } from "../utils/toastUtils";
import { Box, Button } from "@chakra-ui/react";

export default function NeigungDerModuleSection({ selectedAnlageId }) {
  const [neigung, setNeigung] = useState("");

    // ✅ LOAD existing data
  useEffect(() => {
    if (!selectedAnlageId) return;

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/neigungmodule/anlage/${selectedAnlageId}`)
      .then((res) => {
        if (res?.data?.neigung !== undefined) {
          setNeigung(res.data.neigung.toString());
        }
      })
      .catch(() => {
        // no existing neigung → keep empty
        setNeigung("");
      });
  }, [selectedAnlageId]);

const handleSave = async () => {
  if (neigung === "") {
    showError("Fehler!", "Bitte einen Wert eingeben.");
    return;
  }

  const payload = {
    anlage: { id: selectedAnlageId },
    neigung: parseFloat(neigung),
  };

  try {
    // try load existing
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/neigungmodule/anlage/${selectedAnlageId}`
    );

    // update
    await axios.put(
      `${process.env.REACT_APP_API_URL}/api/neigungmodule/${res.data.id}`,
      payload
    );

    showSuccess("Gespeichert", "Neigung der Module wurde aktualisiert");
  } catch {
    // create
    await axios.post(
      `${process.env.REACT_APP_API_URL}/api/neigungmodule`,
      payload
    );

    showSuccess("Gespeichert", "Neigung der Module wurde gespeichert");
  }
};

  return (
       <Box 
          p={8} 
          bg="white" 
          borderRadius="xl" 
          boxShadow="md" 
          mt={6} 
          mb={10} 
          maxW="fit-content"
        >
      <h3
        style={{
          marginBottom: 16,
          color: "#000000",
          fontWeight: "700",
          textTransform: "uppercase",
          marginLeft: 0,
          fontSize: "24px"
        }}
      >
        NEIGUNG DER MODULE
      </h3>

      <div
        style={{
          background: "#f7fafc",
          padding: 16,
          borderRadius: 8,
          display: "flex",
          alignItems: "center",
          gap: 12,
          width: "fit-content",
        }}
      >
        <label style={{ fontWeight: 500 }}>Neigung der Module: </label>
        <input
          type="number"
          step="0.1"
          value={neigung}
          onChange={(e) => setNeigung(e.target.value)}
          style={{
            padding: "6px 10px",
            borderRadius: 6,
            border: "1px solid #ccc",
            width: "120px",
          }}
        />
        <span>Grad</span>
        <Button
          type="button"
          bg="#B8860B"
         _hover={{ bg: "#C99414" }}
        size="lg"
        width="fit-content"
          onClick={handleSave}
        >
          Speichern
        </Button>
      </div>
    </Box>
  );
}